import { useState, Suspense, useCallback, useRef, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { AgGridColumn, AgGridReact } from "ag-grid-react";
import getAgGridHeight from "../../../../utils/commonFunctions/getAgGridHeight";

// import { Pagination } from "@material-ui/lab";
import { CustomFilter, CustomFloatingFilter, CustomPagination } from "../../../shared";
import {
	Box,
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
	Switch,
	Tab,
	Tabs,
	Tooltip,
	useMediaQuery,
	withStyles
} from "@material-ui/core";
import IconButton from "@material-ui/core/IconButton";
import VisibilityIcon from "@material-ui/icons/Visibility";
import PublishIcon from "@material-ui/icons/Publish";
import DeleteIcon from "@material-ui/icons/Delete";
import { Group, GroupBranding, GroupsAndLocations } from "../../../../@types/group.types";
import { DialogProps } from "../../../../@types/dialogProps.types";
import {
	CustomImageDialog,
	CustomImageUploadDialog,
	CustomImageUploadDialogProps
} from "../../../../@types/components/dialogProps.types";
import { CellValueChangedEvent, ColumnApi, GridApi, GridReadyEvent } from "ag-grid-community";
import { PaginationQuery, PaginationTypes } from "../../../../@types/pagination.types";
import { AuthContext, GroupContext, UIContext } from "../../../../contexts";
import { ADMIN_DASHBOARD_HEADER } from "../../../../constants/caption/dashboardHeader";
import { api } from "../../../../utils/api";
import { LazyCustomDialog, LazyCustomImageDialog, LazyCustomImageUploadDialog } from "../../../shared";
import GroupAddIcon from "@material-ui/icons/GroupAdd";
import GroupIcon from "@material-ui/icons/Group";
import EditIcon from "@material-ui/icons/Edit";

import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import getLimit from "../../../../utils/pagination/getLimit";
import generateImageDialogLink from "../../../../utils/commonFunctions/generateImageDialogLink";
import generateImageUrl from "../../../../utils/commonFunctions/imageUrl";
import { trackPromise } from "react-promise-tracker";
import CircularLoader from "../../../shared/loader/CircularLoader";

const PurpleSwitch = withStyles({
	switchBase: {
		color: "#474747",
		"&$checked": {
			color: "#359a4c"
		},
		"&$checked + $track": {
			backgroundColor: "rgba(40, 167, 69, 0.8)"
		}
	},
	checked: {},
	track: {}
})(Switch);

const GroupHome = () => {
	const [value, setValue] = useState<number>(0);
	const [inactive, setInactive] = useState([]);
	const [loading, setLoading] = useState(true);
	const [groups, setGroups] = useState<Group[]>([]);
	const { user } = useContext(AuthContext);
	const [assignedGroups, setAssignedGroups] = useState([]);
	const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
	const [selectedGroupNumber, setSelectedGroupNumber] = useState<number | null>(null);
	const [gridHeight, setGridHeight] = useState<string>("400px");
	const [activateDialogOpen, setActivateDialogOpen] = useState(false);
	const [selectedGroupForActivation, setSelectedGroupForActivation] = useState<GroupsAndLocations | null>(null);
	const [groupBranding, setGroupBranding] = useState<GroupBranding>({
		group_number: 220,
		logo: {},
		favicon: {}
	});

	const [groupsFilterSchema, setGroupsFilterSchema] = useState({
		name: { value: null, type: null },
		group_number: { value: null, type: null },
		email: { value: null, type: null }
	});
	const [imageDialogProps, setImageDialogProps] = useState<CustomImageDialog>({
		openDialog: false,
		image: undefined,
		handleCloseCallback: () =>
			setImageDialogProps(
				Object.assign({}, imageDialogProps, {
					openDialog: false
				})
			)
	});
	const [imageUploadProps, setImageUploadProps] = useState<CustomImageUploadDialog>({
		openDialog: false,
		title: "Upload Group Logo",
		imageSrc: groupBranding.logo,
		uploadFields: [
			{
				buttonLabel: "Upload",
				callback: async (event: React.ChangeEvent<HTMLInputElement>) => {
					const { files } = event.target;
					if (files && files[0]) {
						setImageUploadProps((prevImageUploadProps: CustomImageUploadDialog) =>
							Object.assign(
								{},
								{
									...prevImageUploadProps,
									imageSrc: files[0]
								}
							)
						);
					}
				}
			}
		],
		actions: [
			{
				label: "Cancel",
				callback: () => {
					setImageUploadProps(Object.assign({}, imageUploadProps, { openDialog: false }));
					setGroupBranding(
						Object.assign({}, groupBranding, {
							logo: {}
						})
					);
					window.location.reload();
				}
			}
		]
	});
	const [customDialogProps, setCustomDialogProps] = useState<DialogProps>({
		openDialog: false,
		title: "Do you want to delete the image?",
		content: "Make Sure before deletion",
		actions: [
			{
				label: "Cancel",
				name: "cancel",
				callback: () => {
					setCustomDialogProps(Object.assign({}, customDialogProps, { openDialog: false }));
				}
			},
			{
				label: "Yes",
				name: "submit",
				callback: async () => {
					const focusedCell = agGridRef.current.api.getFocusedCell();
					const row = agGridRef.current.api.getDisplayedRowAtIndex(focusedCell.rowIndex);
					const {
						data: { group_number }
					} = row;
					await api.groupBranding.deleteGroupBranding(group_number);
					getGroups();
					setCustomDialogProps(
						Object.assign({}, customDialogProps, {
							openDialog: false
						})
					);
					window.location.reload();
				}
			}
		]
	});
	const [agGridAPI, setAgGridAPI] = useState<GridApi | null>(null);
	// eslint-disable-next-line no-unused-vars
	const [agGridColumnAPI, setAgGridColumnAPI] = useState<ColumnApi | null>(null);
	const agGridRef = useRef<any>(null);
	const [limit, setLimit] = useState<number | null>(null);
	const [pagination, setPagination] = useState<PaginationTypes>({
		currentPage: 1,
		pageCount: undefined
	});
	const { currentPage, pageCount } = pagination;
	const [isRowSelected, setIsRowSelected] = useState(false);
	const navigate = useNavigate();
	const xl = useMediaQuery("(min-width:1600px)");
	const lg = useMediaQuery("(min-width:1200px)");
	const md = useMediaQuery("(min-width:800px)");
	const sm = useMediaQuery("(min-width:600px)");
	const xs = useMediaQuery("(min-width:400px)");
	const _limit = getLimit(xl, lg, md, sm, xs);
	const { setDashboardHeader } = useContext(UIContext);

	const { groupInformation, locationInformation, setCurrentGroup, setGroupInformation, setLocationInformation } =
		useContext(GroupContext);

	const handleAgGridReady = (params: GridReadyEvent) => {
		// eslint-disable-next-line no-unused-vars
		const { api, columnApi } = params;
		setAgGridAPI(api);
		setAgGridColumnAPI(columnApi);
		const columnIds: any[] = [];
		columnApi?.getAllColumns()?.forEach((column: any) => {
			columnIds.push(column.colId);
		});
		columnApi.autoSizeColumns(columnIds);
	};

	const handleFirstDataRendered = (params: any) => {
		params.api.sizeColumnsToFit();
		params.columnApi.setColumnWidth("action", "100%", true);
	};

	const handleSeeDetailsClick = useCallback(() => {
		if (agGridRef?.current) {
			const focusedCell = agGridRef.current.api.getFocusedCell();
			const row = agGridRef.current.api.getDisplayedRowAtIndex(focusedCell.rowIndex);
			const {
				data: { group_number }
			} = row;
			console.log("data", row.data);

			setCurrentGroup(Object.assign({}, row.data));
			navigate(`/employer?gn=${group_number}`);
		}
	}, [navigate]);

	const handleActionButtonRender = () => {
		return (
			<Button className="ag-grid-cell-button" variant="outlined" onClick={handleSeeDetailsClick}>
				See Details
			</Button>
		);
	};

	const handleViewImageChange = () => {
		const focusedCell = agGridRef.current.api.getFocusedCell();
		const row = agGridRef.current.api.getDisplayedRowAtIndex(focusedCell.rowIndex);
		const {
			data: { branding }
		} = row;
		setImageDialogProps(
			Object.assign({}, imageDialogProps, {
				openDialog: true,
				// image: `http://14.96.189.251:4000/api/v1/file/${branding.logo.filename}`
				image: generateImageUrl(branding.logo)
			})
		);
	};

	const handleDeleteChange = () => {
		setCustomDialogProps(
			Object.assign({}, customDialogProps, {
				openDialog: true
			})
		);
	};

	const handleCloseCustomDialogClick = useCallback(() => {
		setCustomDialogProps(
			Object.assign({}, customDialogProps, {
				openDialog: false
			})
		);
	}, [customDialogProps]);

	const handleUploadChange = (_imageUploadProps: CustomImageUploadDialog) => {
		// console.log("_imageUploadProps", _imageUploadProps);
		const focusedCell = agGridRef.current.api.getFocusedCell();
		const row = agGridRef.current.api.getDisplayedRowAtIndex(focusedCell.rowIndex);
		setImageUploadProps(
			Object.assign({}, _imageUploadProps, {
				openDialog: true,
				uploadFields: [
					{
						buttonLabel: "Upload",
						callback: async (event: React.ChangeEvent<HTMLInputElement>) => {
							const { files } = event.target;
							if (files && files[0]) {
								setImageUploadProps(
									Object.assign({}, _imageUploadProps, {
										imageSrc: files[0],
										openDialog: true,
										actions: [
											..._imageUploadProps.actions,
											{
												label: "Submit",
												callback: async () => {
													const {
														data: { group_number, branding }
													} = row;
													// navigate("/employer");
													const formData: FormData = new FormData();
													formData.append("logo_attachment", files[0]);
													formData.append(
														"group_branding",
														JSON.stringify({
															group_number,
															logo: null,
															favicon: null
														})
													);
													// console.log("files[0]", files[0]);
													let groupBranding;
													if (branding?._id) {
														groupBranding = await api.groupBranding.editGroupBranding(
															formData
														);
													} else {
														groupBranding = await api.groupBranding.addGroupBranding(
															formData
														);
													}
													// console.log("groupBranding", groupBranding);
													setImageUploadProps(
														Object.assign({}, _imageUploadProps, { openDialog: false })
													);
													// setGroupBranding(
													// 	Object.assign({}, groupBranding, {
													// 		logo: null
													// 	})
													// );
													setImageUploadProps(
														Object.assign({}, _imageUploadProps, {
															openDialog: false
														})
													);
													getGroups();
													alert("Successfully Uploaded");
													window.location.reload();
												}
											}
										]
									})
								);
							}
						}
					}
				]
			})
		);
	};

	const handleLogoVisibilityRender = (
		// 	{
		// 	value,
		// 	imageUploadProps
		// }: {
		// 	value: any;
		// 	imageUploadProps: CustomImageUploadDialog;
		// }
		{ data }: { data: any }
	) => {
		// console.log("value", value);
		return (
			<div>
				{/* {value === null ? (
					<div style={{ marginLeft: 15 }}>
						<IconButton aria-label="visibility">
							<PublishIcon onClick={() => handleUploadChange(imageUploadProps)} />
						</IconButton>
					</div>
				) : ( */}
				<>
					<Tooltip title="View" enterDelay={500} leaveDelay={200} arrow>
						{/* <IconButton onClick={handleViewImageChange}> */}
						<IconButton onClick={() => handleViewClick(data.group_number)}>
							<VisibilityIcon />
						</IconButton>
					</Tooltip>
					{/* <Tooltip title="Upload" enterDelay={500} leaveDelay={200} arrow>
							<IconButton onClick={() => handleUploadChange(imageUploadProps)}>
								<PublishIcon />
							</IconButton>
						</Tooltip>
						<Tooltip title="Delete" enterDelay={500} leaveDelay={200} arrow>
							<IconButton onClick={handleDeleteChange}>
								<DeleteIcon />
							</IconButton>
						</Tooltip> */}
				</>
				{/* )} */}
			</div>
		);
	};

	const handleSelectionChanged = useCallback(() => {
		const selectedRow = agGridAPI?.getSelectedRows()[0];
		if (selectedRow) {
			setIsRowSelected(true);
		} else {
			setIsRowSelected(false);
		}
	}, [agGridAPI]);

	const handlePageChange = useCallback(
		(event: React.ChangeEvent<unknown>, page: number) => {
			setPagination(
				Object.assign({}, pagination, {
					currentPage: page
				})
			);
		},
		[pagination]
	);

	const handleCellValueRender = ({ value }: { value: string }) => {
		return <div>{value ? <div>{value}</div> : <div style={{ marginLeft: 15 }}>N/A</div>}</div>;
	};

	const functionToBePassed = () => {
		// console.log("I am functionToBePassed");
	};

	const getAssignGroups = useCallback(async () => {
		if (!user?._id) return;
		try {
			setLoading(true);

			const params = {
				user_id: user?._id
			};
			const response = await trackPromise(api.assignGroupsAndLocation.getAssignedGroupsAndLocations(params));

			// console.log("response=========>", response.groupsAndLocations);
			setInactive(Object.assign([], response.groupsAndLocations));
			if (response) {
				const _assignedGroups: any[] = [];
				response.groupsAndLocations.forEach((group: any) => {
					if (group.assigned_group_info) {
						_assignedGroups.push(group);
					}
				});

				setAssignedGroups(Object.assign([], _assignedGroups));
			}
		} catch (err) {
			console.log(err);
		} finally {
			setLoading(false);
		}
	}, [user?._id]);

	const getGroups = useCallback(async () => {
		const paginationQuery: PaginationQuery = {
			page: 1,
			limit: 3000
		};
		const paginatedResult = await trackPromise(api.assignGroupsAndLocation.getAssignedGroups(paginationQuery));
		// console.log(paginatedResult, "paginatedResult");
		setGroups(Object.assign([], paginatedResult.groups));
		agGridAPI?.refreshCells();
	}, [agGridAPI]);

	// const editGroup = useCallback(async () => {}, []);

	const inactiveGroups = inactive
		// eslint-disable-next-line arrow-parens
		.filter((group: any) => group.status === "DRAFT");

	const handleLabelChange = (_event: any, newValue: number) => {
		setValue(newValue);
	};

	const StatusSwitchRenderer = ({ value }: { value: string }) => {
		return value;
	};

	const handleEditClick = (groupNumber: number) => {
		navigate(`/create-group?gn=${groupNumber}`);
	};
	const handleViewClick = (groupNumber: number) => {
		navigate(`/view-group?gn=${groupNumber}`);
	};

	const handleConfirmDelete = useCallback(async () => {
		if (!selectedGroupNumber) return;

		try {
			const response: any = await trackPromise(api.group.deleteGroup(selectedGroupNumber));

			if (response.status === 200) {
				alert("Group deleted successfully!");
			} else {
				alert("Failed to delete group!");
			}
		} catch (error) {
			console.error("Error deleting group:", error);
			alert("An error occurred while deleting the group.");
		} finally {
			setDeleteDialogOpen(false);
			setSelectedGroupNumber(null);
		}
	}, [selectedGroupNumber]);

	const handleDeleteClick = useCallback((groupNumber: number) => {
		setSelectedGroupNumber(groupNumber);
		setDeleteDialogOpen(true);
	}, []);

	const handleActivateClick = useCallback(async (groupData: GroupsAndLocations) => {
		const group_number = groupData.group_number;
		try {
			await trackPromise(api.group.updateGroupStatus(group_number));

			alert("Group activated successfully!");
			getAssignGroups();
		} catch (err) {
			console.error("Failed to assign group", err);
			alert("Activation failed.");
		}
	}, []);

	const handleInactiveActionRender = ({ data }: { data: any }) => {
		return (
			<div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
				<Tooltip title="Edit" enterDelay={200} leaveDelay={200} arrow>
					<IconButton onClick={() => handleEditClick(data.group_number)}>
						<EditIcon />
					</IconButton>
				</Tooltip>
				<Tooltip title="Delete" enterDelay={200} leaveDelay={200} arrow>
					<IconButton onClick={() => handleDeleteClick(data.group_number)}>
						<DeleteIcon />
					</IconButton>
				</Tooltip>
				<Button
					className="ag-grid-cell-button"
					variant="outlined"
					onClick={() => {
						setSelectedGroupForActivation(data);
						setActivateDialogOpen(true);
					}}
				>
					Activate
				</Button>
			</div>
		);
	};

	const getGroupCount = useCallback(async () => {
		if (limit) {
			const groupCount = await api.group.getGroupCount();
			const pageCount = Math.ceil(groupCount / limit);
			// console.log("pageCount", pageCount);
			setPagination(Object.assign({}, pagination, { pageCount }));
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [limit]);

	const handleClickCreateGroup = () => {
		navigate("/create-group");
	};

	useEffect(() => {
		setDashboardHeader(ADMIN_DASHBOARD_HEADER.all_group);
		if (user?._id) {
			getGroups();
			getAssignGroups();
		}
		// }, [getGroups, getAssignGroups, setDashboardHeader, handleConfirmDelete]);
	}, [user?._id]);

	useEffect(() => {
		const _gridHeight = getAgGridHeight(groups.length);
		setGridHeight(_gridHeight);
	}, [groups.length]);

	// console.log("imgSrc", imageUploadProps);
	// console.log("assignedGroups====>", assignedGroups);
	// console.log("value=====>", value);

	return (
		<div className="group-home-page">
			<Suspense fallback={<div />}>
				<LazyCustomImageDialog dialogProps={imageDialogProps} />
			</Suspense>
			<Suspense fallback={<div />}>
				<LazyCustomDialog dialogProps={customDialogProps} handleClose={handleCloseCustomDialogClick} />
			</Suspense>
			<Suspense fallback={<div />}>
				<LazyCustomImageUploadDialog dialogProps={imageUploadProps} />
			</Suspense>
			<div className="pf-action-button-container" id="pf-action-button-container">
				<Button className="button-green" variant="contained" onClick={handleClickCreateGroup}>
					<span className="button-label-with-icon">Create Group</span>
					<span>
						<GroupIcon className="button-icon" />
					</span>
				</Button>
			</div>

			{/* <div className="group-home-pg-grid-container">
				<div className="ag-theme-alpine" style={{ height: gridHeight, width: "100%" }}>
					<AgGridReact
						ref={agGridRef}
						rowData={groups}
						onGridReady={handleAgGridReady}
						onFirstDataRendered={handleFirstDataRendered}
						rowSelection={"Single"}
						animateRows
						defaultColDef={{
							filter: "agTextColumnFilter",
							floatingFilter: true,
							resizable: true
						}}
						onSelectionChanged={handleSelectionChanged}
						frameworkComponents={{
							handleActionButtonRender: handleActionButtonRender,
							handleLogoVisibilityRender: handleLogoVisibilityRender,
							handleCellValueRender: handleCellValueRender,
							customFloatingFilter: CustomFloatingFilter,
							customFilter: CustomFilter,
							schema: groupsFilterSchema,
							functionToBePassed: functionToBePassed,
							setPayloadSchema: setGroupsFilterSchema,
							setParentSchema: setGroups
						}}
						onCellValueChanged={(params: CellValueChangedEvent) => {
							params.api.refreshCells({
								force: true,
								columns: ["branding"]
							});
						}}
						enableCellChangeFlash={true}
					>
						<AgGridColumn
							field="name"
							headerName="Group Name"
							// floatingFilterComponentParams={{ suppressFilterButton: true }}
							cellRenderer="handleCellValueRender"
							floatingFilterComponent="customFloatingFilter"
							filter="customFilter"
							onCellClicked={handleSeeDetailsClick}
							cellStyle={() => {
								return { cursor: "pointer" };
							}}
						></AgGridColumn>
						<AgGridColumn
							field="group_number"
							headerName="Group Number"
							// floatingFilterComponentParams={{ suppressFilterButton: true }}
							cellRenderer="handleCellValueRender"
							floatingFilterComponent="customFloatingFilter"
							filter="customFilter"
							onCellClicked={handleSeeDetailsClick}
							cellStyle={() => {
								return { cursor: "pointer" };
							}}
						></AgGridColumn>
						<AgGridColumn
							field="email"
							headerName=" Email"
							floatingFilterComponentParams={{ suppressFilterButton: true }}
							cellRenderer="handleCellValueRender"
						></AgGridColumn>
						<AgGridColumn
							field="branding"
							headerName="Group Logo"
							cellRenderer="handleLogoVisibilityRender"
							filter={false}
							cellRendererParams={{ imageUploadProps }}
						></AgGridColumn>
						<AgGridColumn
							field="action"
							headerName="Action"
							cellRenderer="handleActionButtonRender"
							filter={false}
						></AgGridColumn>
					</AgGridReact>
				</div>
			</div> */}
			<div className="group-home-pg-grid-container">
				<Box sx={{ borderBottom: 1, borderColor: "divider" }}>
					<Tabs
						value={value}
						onChange={handleLabelChange}
						aria-label="Group Tabs"
						TabIndicatorProps={{
							style: { border: "none", backgroundColor: "#558b2f" }
						}}
						className="glb-tab-panel"
					>
						<Tab label={"Active Groups"} className="glb-tab-label" />
						<Tab label={"Inactive Groups"} className="glb-tab-label" />
					</Tabs>
				</Box>

				<Dialog open={deleteDialogOpen} onClose={() => setDeleteDialogOpen(false)}>
					<DialogTitle style={{ fontWeight: "bold", color: "#d32f2f" }}>Confirm Deletion</DialogTitle>
					<DialogContent style={{ paddingTop: 1 }}>Are you sure you want to delete this group?</DialogContent>
					<DialogActions>
						<Button onClick={() => setDeleteDialogOpen(false)} variant="outlined" color="primary">
							Cancel
						</Button>
						<Button onClick={handleConfirmDelete} variant="contained" color="inherit">
							Delete
						</Button>
					</DialogActions>
				</Dialog>

				<Dialog open={activateDialogOpen} onClose={() => setActivateDialogOpen(false)}>
					<DialogTitle style={{ fontWeight: "bold", color: "#d32f2f" }}>Confirm Activation</DialogTitle>
					<DialogContent style={{ paddingTop: 1 }}>
						Are you sure you want to activate this group?
					</DialogContent>
					<DialogActions>
						<Button onClick={() => setActivateDialogOpen(false)} variant="outlined" color="primary">
							Cancel
						</Button>
						<Button
							onClick={async () => {
								if (selectedGroupForActivation) {
									await handleActivateClick(selectedGroupForActivation);
								}
								setActivateDialogOpen(false);
							}}
							variant="contained"
						>
							Activate
						</Button>
					</DialogActions>
				</Dialog>

				{value === 0 &&
					(loading ? (
						<CircularLoader />
					) : (
						<div className="ag-theme-alpine" style={{ height: "400px", width: "100%", marginTop: "30px" }}>
							<AgGridReact
								ref={agGridRef}
								rowData={assignedGroups}
								onGridReady={handleAgGridReady}
								onFirstDataRendered={handleFirstDataRendered}
								rowSelection={"Single"}
								animateRows
								defaultColDef={{
									filter: "agTextColumnFilter",
									floatingFilter: true,
									resizable: true
								}}
								onSelectionChanged={handleSelectionChanged}
								frameworkComponents={{
									handleActionButtonRender: handleActionButtonRender,
									handleLogoVisibilityRender: handleLogoVisibilityRender,
									handleCellValueRender: handleCellValueRender,
									customFloatingFilter: CustomFloatingFilter,
									customFilter: CustomFilter,
									schema: groupsFilterSchema,
									functionToBePassed: functionToBePassed,
									setPayloadSchema: setGroupsFilterSchema,
									setParentSchema: setGroups
								}}
								onCellValueChanged={(params: CellValueChangedEvent) => {
									params.api.refreshCells({
										force: true,
										columns: ["branding"]
									});
								}}
								enableCellChangeFlash={true}
							>
								<AgGridColumn
									field="name"
									headerName="Group Name"
									cellRenderer="handleCellValueRender"
									floatingFilterComponent="customFloatingFilter"
									filter="customFilter"
									onCellClicked={handleSeeDetailsClick}
									cellStyle={{ cursor: "pointer" }}
								></AgGridColumn>
								<AgGridColumn
									field="group_number"
									headerName="Group Number"
									cellRenderer="handleCellValueRender"
									floatingFilterComponent="customFloatingFilter"
									filter="customFilter"
									onCellClicked={handleSeeDetailsClick}
									cellStyle={{ cursor: "pointer" }}
								></AgGridColumn>
								<AgGridColumn
									field="email"
									headerName=" Email"
									floatingFilterComponentParams={{ suppressFilterButton: true }}
									cellRenderer="handleCellValueRender"
								></AgGridColumn>
								<AgGridColumn
									field="branding"
									headerName="Details"
									cellRenderer="handleLogoVisibilityRender"
									filter={false}
									cellRendererParams={{ imageUploadProps }}
								></AgGridColumn>
								<AgGridColumn
									field="action"
									headerName="Action"
									cellRenderer="handleActionButtonRender"
									filter={false}
								></AgGridColumn>
							</AgGridReact>
						</div>
					))}

				{value === 1 && (
					<div className="ag-theme-alpine" style={{ height: "400px", width: "100%", marginTop: "30px" }}>
						<AgGridReact
							ref={agGridRef}
							rowData={inactiveGroups}
							onGridReady={handleAgGridReady}
							onFirstDataRendered={handleFirstDataRendered}
							rowSelection={"Single"}
							animateRows
							defaultColDef={{
								filter: "agTextColumnFilter",
								floatingFilter: true,
								resizable: true
							}}
							onSelectionChanged={handleSelectionChanged}
							frameworkComponents={{
								handleInactiveActionRender: handleInactiveActionRender,
								handleLogoVisibilityRender: handleLogoVisibilityRender,
								handleCellValueRender: handleCellValueRender,
								customFloatingFilter: CustomFloatingFilter,
								customFilter: CustomFilter,
								schema: groupsFilterSchema,
								functionToBePassed: functionToBePassed,
								setPayloadSchema: setGroupsFilterSchema,
								setParentSchema: setGroups,
								statusSwitchRenderer: StatusSwitchRenderer
							}}
							onCellValueChanged={(params: CellValueChangedEvent) => {
								params.api.refreshCells({
									force: true,
									columns: ["branding"]
								});
							}}
							enableCellChangeFlash={true}
						>
							<AgGridColumn
								field="name"
								headerName="Group Name"
								cellRenderer="handleCellValueRender"
								floatingFilterComponent="customFloatingFilter"
								filter="customFilter"
								onCellClicked={handleSeeDetailsClick}
								cellStyle={{ cursor: "pointer" }}
							></AgGridColumn>
							<AgGridColumn
								field="group_number"
								headerName="Group Number"
								cellRenderer="handleCellValueRender"
								floatingFilterComponent="customFloatingFilter"
								filter="customFilter"
								onCellClicked={handleSeeDetailsClick}
								cellStyle={{ cursor: "pointer" }}
							></AgGridColumn>
							<AgGridColumn
								field="email"
								headerName=" Email"
								floatingFilterComponentParams={{ suppressFilterButton: true }}
								cellRenderer="handleCellValueRender"
							></AgGridColumn>
							<AgGridColumn
								field="branding"
								headerName="Details"
								cellRenderer="handleLogoVisibilityRender"
								filter={false}
								cellRendererParams={{ imageUploadProps }}
							></AgGridColumn>
							<AgGridColumn
								field="status"
								headerName="Status"
								cellRenderer="statusSwitchRenderer"
								filter={false}
							/>
							<AgGridColumn
								field="action"
								headerName="Action"
								cellRenderer="handleInactiveActionRender"
								filter={false}
							/>
						</AgGridReact>
					</div>
				)}
			</div>

			{/* <div className="custom-pagination" id="custom-pagination">
				<CustomPagination pageCount={pageCount} currentPage={currentPage} handlePageChange={handlePageChange} />
			</div> */}
		</div>
	);
};

export default GroupHome;
